import React, { Component } from 'react'
import pt from 'prop-types'
import { get, isEmpty } from 'lodash-es'
import { connect } from 'react-redux'
import SortableContainer from './SortableContainer'
import { makeGetUserById } from '../../modules/entities'
import { requestUpdateSortCustomFeedSections } from '../../modules/feeds'
import IconPlus from '../icon/IconPlus'
import { openMod } from '../../modules/mods'

import './SectionsMenu.scss'

class SectionsMenu extends Component {
  state = {
    sorting: false,
    saving: false
  }

  render() {
    const { item, requestUpdateSortCustomFeedSections, state, sections, openMod, switchMenu } = this.props

    return sections ? (
      <div
        className={'sections-menu' + (this.state.sorting ? ' sections-menu--sorting' : '')}
        onMouseLeave={() => {
          switchMenu({ status: false })
        }}
      >
        {!isEmpty(sections) && (
          <SortableContainer
            item={item}
            items={sections}
            state={state}
            pinsCount={0}
            isIndexed
            isSortable
            useDragHandle
            lockAxis="y"
            lockToContainerEdges
            lockOffset={'50px'}
            helperContainer={document.getElementsByClassName('sortable-container__appender')[0]}
            loadMoreRows={this.loadMoreRows}
            onSortStart={(_, e) => {
              e.preventDefault()
              this.setState({
                sorting: true
              })
            }}
            onSortEnd={({ oldIndex, newIndex }) => {
              this.setState({
                sorting: false
              })
              requestUpdateSortCustomFeedSections({
                oldIndex,
                newIndex,
                sections
              })
            }}
          />
        )}

        <div
          className="sections-menu__add"
          onMouseDown={() => {
            openMod({ type: 'createSection' })
          }}
        >
          <span className="sections-menu__icon ">
            <IconPlus />
          </span>
          <span className="sections-menu__text">Create section</span>
        </div>
      </div>
    ) : null
  }
}

SectionsMenu.propTypes = {
  requestUpdateSortCustomFeedSections: pt.func,
  item: pt.object,
  state: pt.object,
  sections: pt.array,
  openMod: pt.func,
  switchMenu: pt.func
}

const makeMapStateToProps = () => {
  return (state, props) => {
    const getUser = makeGetUserById()
    return {
      feedsInSectionsProfile: get(state, 'myContent.feedsInSectionsProfile'),
      user: getUser(state, props.userId),
      state: state
    }
  }
}

export default connect(
  makeMapStateToProps,
  {
    openMod,
    requestUpdateSortCustomFeedSections
  }
)(SectionsMenu)
